export default function userSessionCheck() {
  setInterval(() => {
    if (localStorage.getItem('ns_t') == null || !localStorage.getItem('ns_t')) {
      window.location.reload();
    }
  }, 2500);
}
